export const environment = {
    production: false,
    apiUrl: 'https://backend.reload.test.wikipiedra.asmws.net',
    apiVersion: 'v1'
};
